import { Button } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import type { ProviderCoverage } from '../types';

type ProviderActionProps = {
  provider: ProviderCoverage;
  onMatchClick: (provider: ProviderCoverage) => void;
  onGetUpdateClick: (provider: ProviderCoverage) => void;
};

export default function ProviderAction({
  provider,
  onMatchClick,
  onGetUpdateClick,
}: ProviderActionProps) {
  if (provider.health === 'DELAYED' || provider.health === 'CRITICALLY_DELAYED') {
    return (
      <Button
        variant="subtle"
        size="compact-sm"
        rightSection={<IconChevronRight size={14} />}
        onClick={e => {
          e.stopPropagation();
          onGetUpdateClick(provider);
        }}
      >
        Get update
      </Button>
    );
  }

  if (provider.unmatchedCount > 0) {
    return (
      <Button
        variant="subtle"
        size="compact-sm"
        rightSection={<IconChevronRight size={14} />}
        onClick={() => onMatchClick(provider)}
      >
        Match
      </Button>
    );
  }

  return null;
}
